import React from "react";
import { RouteApp } from "router";

import { ThemeProvider } from "styled-components";
import Theme from "context/theme";

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <RouteApp />
    </ThemeProvider>
  );
}

export default App;
